export enum SlideType {
  ROOT = 'root',
  INTERACTIVE = 'interactive',
}
